import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSelector from '@/components/selectors/BaseSelector';

export interface IntervalComplexSelectorProps<T = number | string> {
    value: T;
    onChange: (interval: T) => void;
    intervals: T[];
    unit?: 'minutes' | 'hours';
    label?: string;
}

const IntervalComplexSelector = <T extends number | string = number>({
    value,
    onChange,
    intervals,
    unit = 'minutes',
    label
}: IntervalComplexSelectorProps<T>) => {
    const { t } = useTranslation();

    const formatIntervalLabel = (interval: T): string => {
        if (typeof interval === 'string') {
            return interval;
        }
        return `${interval} ${t(unit)}`;
    };

    const intervalItems = useMemo(
        () =>
            intervals.map((val) => ({
                value: val,
                text: formatIntervalLabel(val)
            })),
        [intervals, unit, t]
    );

    const displayLabel = label ?? t('interval');

    return (
        <BaseSelector
            value={value}
            items={intervalItems}
            itemText="text"
            itemValue="value"
            label={displayLabel}
            onChange={(val) => onChange(val as T)}
        />
    );
};

export default IntervalComplexSelector;
